module.exports = __webpack_public_path__ + "img/download-3-panel-3.0f719e61.png";